export const SAVE_SUCCESS = 'Les modifications ont été enregistrées.';
export const CONSULTANT_REQUIRED = 'Veuillez sélectionner un consultant.';
export const LEAVE_TITLE = 'Quitter sans enregistrer';
export const LEAVE_TEXT =
  "Des modifications n'ont pas été enregistrées. Êtes-vous sûr de vouloir quitter ?";
export const LEAVE_CONFIRM = 'Quitter';
